
import { Options, mixins } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import cloneDeep from 'lodash/cloneDeep'
import { ICampaign } from '@/utils/types'
import { ACTION_CAMPAIGN } from '@/store/actions'
import BaseFormDialogMixin from '../common/mixins/BaseFormDialogMixin.vue'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:onSelect'],
})
export default class CampaignFormModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  campaign!: ICampaign

  isTestMode = false
  form: ICampaign = {
    _id: '',
    app_id: '',
    is_active: false,
    is_test_mode: false,
    campaign_name: '',
    is_traffic_source: true,
  }

  get selectedAppId() {
    return this.$route.params.app_id as string
  }

  get requiredRule() {
    const requiredRule = {
      campaign_name: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.campaign.campaign_name'),
      }),
    }
    return requiredRule
  }

  get modalTitle() {
    return this.isNew ? this.$t('label.campaign.add_new_campaign') : this.$t('label.campaign.edit_campaign')
  }

  onSubmit() {
    this.$refs.formRef
      .validate()
      .then(async (success: boolean) => {
        if (!success) {
          return
        }

        await this.doSave()
      })
      .catch((error: unknown) => {
        console.log('error', error)
      })
  }

  async doSave() {
    const { dispatch } = this.$store
    let item = null
    if (this.isNew) {
      this.form.app_id = this.selectedAppId
      item = await dispatch(ACTION_CAMPAIGN.ADD, {
        ...this.form,
      })
    } else {
      item = await dispatch(ACTION_CAMPAIGN.UPDATE, {
        _id: this.campaign._id,
        ...this.form,
      })
    }

    if (item) {
      this.$emit('update:onSelect', item)

      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
    }

    this.visible = false
  }

  async created() {
    this.form = { ...this.form, ...cloneDeep(this.campaign) }
    this.parentForm = this.form as any
    this.initForm = cloneDeep(this.parentForm)
    this.$nextTick(() => {
      this.$refs.formRef.validate()
    })
  }
}
